<div class="header">
    <h2 mat-dialog-title>{{data?.title | translate}}</h2>
    <button mat-icon-button [mat-dialog-close]="false">
        <mat-icon>close</mat-icon>
    </button>
</div>

<div mat-dialog-content>
    <p [innerHTML]="data?.message | translate"></p>
</div>

<div mat-dialog-actions [align]="'end'">
    <button mat-raised-button [mat-dialog-close]="false" *ngIf="data?.cancelCaption">
        {{data?.cancelCaption | translate}}
    </button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">
        {{data?.confirmCaption | translate}}
    </button>
</div>